import { ComponentView,ViewGenerator, ViewModel } from "binder"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ITemplateSelector } from "../templateSelector";
import { getAsBoolean } from "../utilities";
import { ContentViewModel } from "./content-viewModel"

export class ContentView extends ComponentView<ContentViewModel>{
    GetViewUniqueId(): string {
        return "V-0C58C6EC-98B4-4D9D-9730-7545D620C602"
    }
    loadHtml(): string {
        let element = require('./content.html').default;
        let style = require('./content.less');
        return element;
    }
    constructor() {
       super();
    }

    public set itemtemplateselector(v: ITemplateSelector) { 
        this._itemtemplateselector = v; 
        this.updateInternalContent();
    } public get itemtemplateselector(): ITemplateSelector { return this._itemtemplateselector;} private _itemtemplateselector: ITemplateSelector;
    public set templateselectorfunction(v: string) { 
        this._templateselectorfunction = v; 
        this.updateInternalContent();
    } public get templateselectorfunction(): string { return this._templateselectorfunction;} private _templateselectorfunction: string;
    public set content(v: ViewModel) {
        this._content = v;
        this.updateInternalContent();
    } public get content(): ViewModel { return this._content;} private _content: ViewModel;
    private itemTemplateMapping:{[id:string]:Node}={};
    private itemTemplate : Node;
    public set importanthasselectorfunction(v: boolean) { this._importanthasselectorfunction = getAsBoolean(v); } public get importanthasselectorfunction(): boolean { return this._importanthasselectorfunction;} private _importanthasselectorfunction: boolean;
    public set internalContent(v: ViewModel) { this._internalContent = v; } public get internalContent(): ViewModel { return this._internalContent;} private _internalContent: ViewModel;
    

    updateInternalContent(){
        if((this.importanthasselectorfunction??false)==false){
            this.internalContent = this.content;
        }else{
            if(this.itemtemplateselector!=null || stringIsNullOrEmpty(this.templateselectorfunction)==false){
                this.internalContent = this.content;
            }
        }
    }

    templateSelector(vm){
        let template : any;
        let newNode : Element;
        
        if(this.itemtemplateselector==null && stringIsNullOrEmpty(this.templateselectorfunction)==false){
            let templateSeletorProvider : ViewModel = this.dataContext;
            while(templateSeletorProvider!=null && (<ViewModel>templateSeletorProvider).getTypeId()!="VM-944D0986-9F07-4724-A37B-2DA704DD426D"){
                templateSeletorProvider = templateSeletorProvider.parentViewModel;
            }
            if(templateSeletorProvider!=null){
                this.itemtemplateselector = (<any>templateSeletorProvider).templateSelector
            }
        }
        if(this.itemtemplateselector && this.itemtemplateselector.getTemplate){
            template = this.itemtemplateselector.getTemplate(vm,this.templateselectorfunction);
            if(template){
                newNode = ViewGenerator.CreateFromPrototypeAndViewModel(template,vm);
            }
        }
        if(newNode==null){
            if(vm){
                let typeId = vm.getTypeId();
                let result = this.itemTemplateMapping[typeId];
                if(result)
                    newNode = ViewGenerator.GetNodeByTemplate(vm,result);
            }
            if(newNode==null)
            newNode =  ViewGenerator.GetNodeByTemplate(vm,this.itemTemplate);
        }
        return newNode;
    }
    append(...nodes: (Node | string)[]): void{
        nodes.forEach(node=>{
            if(node instanceof HTMLElement && node.classList.contains("template")){
                this.itemTemplate = super.removeAsTemplate(node);
            }else if(node instanceof HTMLElement){
                for (let index = 0; index < node.classList.length; index++) {
                    const element = node.classList[index];
                    if(element.startsWith('template-')){
                        let template = super.removeAsTemplate(node);
                        let type = element.substring(9);
                        this.itemTemplateMapping[type]=template;
                        break;
                    }
                }
            }else{
                this.firstlevelElement.append(node);
            }
        })
    }
}
